import i18n from 'i18next'; import { useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Box, Card, CardContent, Container, Divider, Link, Typography, Grid } from '@material-ui/core';
import {
  LoginJWT } from
  '../../components/authentication/login';
import Logo from '../shared/Logo';
import gtm from '../../lib/gtm';

const Login = () => {
  useEffect(() => {
    gtm.push({ event: 'page_view' });
  }, []);

  return (
    <>
      <Helmet>
        <title>{i18n.t('Login.giri\u015F_joobid')}</title>
      </Helmet>
      <Box
        className="tp-auth__page"
        sx={{
          backgroundColor: 'background.default',
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh'
        }}
      >

        <Container
          maxWidth="lg"
          sx={{ py: '80px' }}
        >

          <Grid
            container
            spacing={3}
            sx={{ justifyContent: 'space-between' }}
          >

            <Grid
              item
              xs={12}
              md={7}
              className="jb-img-wrapper"
            >

              <img
                alt=""
                src="/static/assets/img/auth-login.svg"
                width={100}
              />

            </Grid>
            <Grid
              item
              xs={12}
              md={5}
            >

              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  mb: 2
                }}
              >

                <RouterLink to="/">
                  <Logo
                    sx={{
                      height: 40,
                      width: 40
                    }}
                  />

                </RouterLink>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  mb: 2
                }}
              >

                <div>
                  <Typography
                    color="textPrimary"
                    gutterBottom
                    variant="h4"
                    align="center"
                  >
                    {i18n.t('Login.joobid_e_ho\u015Fgeldiniz')}

                  </Typography>
                  <Typography
                    color="textPrimary"
                    gutterBottom
                    variant="h6"
                    align="center"
                  >
                    {i18n.t('Login.l\xFCtfen_hesab\u0131n\u0131za_giri\u015F_yap\u0131n')}

                  </Typography>
                </div>
              </Box>
              <Card>
                <CardContent
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    p: 4
                  }}
                >

                  <Box
                    sx={{
                      alignItems: 'center',
                      display: 'flex',
                      justifyContent: 'space-between',
                      mb: 0,
                      mt: 2
                    }}
                  >

                    <div>
                      <Typography
                        color="textPrimary"
                        gutterBottom
                        variant="h4"
                        className="jb-auth-title"
                      >
                        {i18n.t('Login.kullan\u0131c\u0131_giri\u015Fi')}

                      </Typography>
                    </div>
                  </Box>
                  <Box
                    sx={{
                      flexGrow: 1,
                      mt: 3
                    }}
                  >

                    <LoginJWT />
                  </Box>
                  <Divider sx={{ my: 3 }} />
                  <Link
                    color="textSecondary"
                    component={RouterLink}
                    to="/register"
                    variant="body2"
                  >
                    {i18n.t('Login.yeni_hesap_olu\u015Ftur')}

                  </Link>
                  <Link
                    color="textSecondary"
                    component={RouterLink}
                    sx={{ mt: 1 }}
                    to="/password-recovery"
                    variant="body2"
                  >
                    {i18n.t('Login.\u015Fifremi_unuttum')}

                  </Link>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default Login;
